import plot1data from "./plot1data";
import plot1alt from "./plot1alt";
import plot1 from "./plot1";
import plot2 from "./plot2";
import plot3 from "./plot3";
import plot4 from "./plot4";
import plot5 from "./plot5";
import plot6 from "./plot6";
import alttext1 from "./alttext1";
import alttext2 from "./alttext2";
import alttext3 from "./alttext3";
import alttext4 from "./alttext4";
import alttext5 from "./alttext5";
import alttext6 from "./alttext6";

const plotFunctions = {
  plot1data,
  plot1alt,
  plot1,
  plot2,
  plot3,
  plot4,
  plot5,
  plot6,
  alttext1,
  alttext2,
  alttext3,
  alttext4,
  alttext5,
  alttext6,
};

export default plotFunctions;
